import styles from './menu_bar_hamburger.module.css'
export default function Hamburger(props) {
  return (
    <button className={`${styles.hamburger} ${styles.hamburgerElastic} ${props.isActive ? styles.isActive : ""}`} type="button" onClick={props.onToggle}>
      <span className={styles.hamburgerBox}>
        <span className={styles.hamburgerInner}></span>
      </span>
    </button>  
  )
}